import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Droplets, Heart, Shield } from 'lucide-react';
const benefits = [{
  icon: Moon,
  title: 'Durchgehender Tiefschlaf',
  text: 'Unterstützt ununterbrochene Tiefschlafphasen, damit Ihr Körper sich vollständig regenerieren kann. Kein Aufwachen um 2, 3 oder 4 Uhr morgens mehr.'
}, {
  icon: Droplets,
  title: 'Vollständige Blasenentleerung',
  text: 'Fördert die komplette Entleerung der Blase — das Restharngefühl und der ständige Drang gehören der Vergangenheit an.'
}, {
  icon: Heart,
  title: 'Weniger nächtliche Spannung',
  text: 'Reduziert den Druck auf die Prostata und entspannt die glatte Muskulatur — für spürbare Erleichterung ab den ersten Wochen.'
}, {
  icon: Shield,
  title: 'EU-zertifizierte Qualität',
  text: 'Registriert unter SNPMAPS Nr. AA 15341/2025. Jede Charge laborgeprüft nach europäischen Pharmastandards.'
}];
export function BenefitsSection() {
  return <section className="relative py-28 md:py-32 bg-white text-slate-900 overflow-hidden" data-id="element-29">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-30">
        <div className="text-center mb-20" data-id="element-31">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-slate-900 mb-6" data-id="element-32">
            Vier Säulen für Ihre nächtliche Ruhe
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-33">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-10 rounded-xl shadow-sm border border-slate-200 border-l-4 border-l-brand-500 hover:shadow-md hover:-translate-y-1 transition-all duration-300 group" data-id="element-34">
              <div className="w-16 h-16 rounded-2xl bg-brand-50 flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300" data-id="element-35">
                <benefit.icon className="w-8 h-8 text-brand-500" strokeWidth={1.5} data-id="element-36" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-slate-900 mb-4 group-hover:text-brand-600 transition-colors" data-id="element-37">
                {benefit.title}
              </h3>
              <p className="text-base text-slate-600 leading-loose" data-id="element-38">
                {benefit.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}